import { passkeyKey } from '../state/storageKey';

export const setPassKey = (key: string) => {
  try {
    localStorage.setItem(passkeyKey, key);
  } catch (e) {
    // do something
  }
};

export const removePassKey = () => {
  try {
    localStorage.removeItem(passkeyKey);
  } catch (e) {
    // do something
  }
};

export function generateRandomString(length: number): string {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }
  return result;
}
